import { ZoneType } from 'data/types';

const CONCEALED_TYPE_CODES = new Set(['concealed', 'concealed_high_static']);

export function getPinnedPassiveSpaceIds(zone: ZoneType): Set<string> | null {
  const typeCode = zone.airHandler?.airHandlerTypeCode;
  if (!typeCode || !CONCEALED_TYPE_CODES.has(typeCode)) return null;

  const flagged = new Set(
    zone.zoneItems
      .filter((item) => item.servePassively === true)
      .map((item) => item.structureItemId)
  );
  return flagged.size > 0 ? flagged : null;
}
